'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _keys = require('lodash/keys');

var _keys2 = _interopRequireDefault(_keys);

var _actions = require('../actions.js');

var _actions2 = _interopRequireDefault(_actions);

var _localize = require('linksoft/utils/localize');

var _localize2 = _interopRequireDefault(_localize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BuyAll = function (_Component) {
    (0, _inherits3.default)(BuyAll, _Component);

    function BuyAll() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, BuyAll);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = BuyAll.__proto__ || (0, _getPrototypeOf2.default)(BuyAll)).call.apply(_ref, [this].concat(args))), _this), _this.buyAllClick = function () {
            _this.props.submitChanges();
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(BuyAll, [{
        key: 'render',
        value: function render() {
            var btnClass = "btn btn-blue";
            if (!this.props.hasChanged) {
                btnClass += " disabled";
            }
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'a',
                    { className: btnClass, onClick: this.buyAllClick },
                    (0, _localize2.default)("App:BuyAll")
                ),
                _react2.default.createElement(
                    'span',
                    { className: 'hint-submit' },
                    (0, _localize2.default)("App:AboutEnterSubmit")
                )
            );
        }
    }]);
    return BuyAll;
}(_react.Component);

BuyAll.propTypes = {
    hasChanged: _propTypes2.default.bool.isRequired,
    submitChanges: _propTypes2.default.func.isRequired
};

function mapStateToProps(state, ownProps) {
    return {
        hasChanged: (0, _keys2.default)(state.cart.changes).length > 0
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, {
    submitChanges: _actions2.default.submitChanges
})(BuyAll);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/containers/buy-all.js
// module id = 911
// module chunks = 0